export default __webpack_public_path__ + "static/media/f.ck.2a1ff2b1.png";